export const SearchTypeFileFormat = 6 as const;
export type TSearchTypeFileFormat = typeof SearchTypeFileFormat;

/** elementSubType1 */
export enum FileFormatType {
	ONLY = 0,
	EXCLUDE = 1,
}
